/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_POLICY_LIST } from "../../ProvisionalPageService/graphql";
import { VApplication } from "../../../application";

import { toHeaderCase } from "js-convert-case";
import moment from "moment";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCredentialsListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: IGetCredentialsListProps): Promise<any>;
}

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialsListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let _where1 = args?.where?.filter(
      (item) => item?.column === "policyNumber"
    );
    let _where2 = args?.where?.filter(
      (item) => item?.column !== "policyNumber"
    );
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_POLICY_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where: [
                {
                  column: "type",
                  value: ["ACTUAL"],
                  op: "Equal",
                },
                {
                  column: "status",
                  value: ["EXPIRED"],
                  op: "NotIn",
                },
                ..._where1,
              ],
              order: [
                {
                  column: "purchasedAt",
                  direction: "DESC",
                },
              ],
              relationFilter: {
                purchasedBy: {
                  where: [..._where2],
                  limit: args?.size ?? 10,
                  skip: args?.offset ?? 0,
                },
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyPolicies) {
          let _templateData = this.formatTemplateList(
            res?.data?.getMyPolicies?.data
          );
          return {
            appCardList: _templateData,
            isEmpty: res?.data?.getMyPolicies?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getMyPolicies?.currentPage,
            pageSize: res?.data?.getMyPolicies?.pageSize,
            totalCount: res?.data?.getMyPolicies?.totalCount,
            totalPages: res?.data?.getMyPolicies?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
    // return {
    //   appCardList: config?.appCardList,
    //   activePage: config?.activePage,
    //   pageSize: config?.pageSize,
    //   totalCount: config?.totalCount,
    //   totalPages: config?.totalPages,
    // };
  }

  private formatTemplateList(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          // ribbon:{
          //   title:item?.status,
          //   backgroundColor:this.getColor(item?.status)
          // },
          appCardImage: item?.logo ?? config?.icon,
          appCardTitle: item?.productDefination
            ? `Policy Option ${toHeaderCase(item?.productDefination)}`
            : "",
          appCardDescription: item?.createdAt
            ? moment(item?.createdAt).format("DD/MM/YYYY")
            : "",
          appCardList: [
            {
              name: "Policy No",
              value: item?.policyNumber,
            },
            {
              name: "Status",
              value: toHeaderCase(item?.status ?? "")
            }
          ],
        };
      });

    return _rowData;
  }

  private getColor(status:string){
    switch(status){
      case "PAYMENT_PENDING":
        return "#00FFFF";
      case "ISSUED":
        return "#00ff00";
      case "EVENT_MONITORING":
        return "#7FFFD4";
      case "PAYOUT_INTIMATION":
       return "#454B1B";
      case "PAYOUT_CONFIRMATION":
        return "#7CFC00";
      case "PAYOUT_ACKNOWLEDGED":
        return "#7FFF00";
      case "EXPIRED":
        return "#FA8072";
      case "CANCELED":
        return "#FFA07A";
      default: return null;
   
    }
  }
}
